import React, { useState } from 'react';
import { MetaRow } from 'containers/Manage-Questionnaire/styled-components';
import { Intent, Button, Tooltip } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { DialogWrapper } from 'components/DialogWrapper';
import styled from 'styled-components';
import { AppToaster } from 'components/AppToaster';

const EditRow = ({
  name,
  id,
  archive,
  fetch,
  update,
  content,
  canEdit,
  children,
}) => {
  const [isOpen, toggleOpen] = useState(false);
  const [editing, toggleEdit] = useState(false);

  const handleArchive = () => {
    archive(id)
      .then(() => fetch())
      .catch(err => {
        AppToaster.show({
          message: err.response.data.message,
          intent: Intent.DANGER,
        });
      });
  };
  return (
    <>
      <MetaRow style={{ borderRadius: '0 0 3px 3px' }}>
        {editing ? (
          <>
            {React.cloneElement(children, {
              update,
              fetch,
              content,
              toggleEdit,
              id,
              name,
            })}
          </>
        ) : (
          <>
            <H3>{name}</H3>
            {canEdit && (
              <>
                <Tooltip content="Edit">
                  <Button icon={IconNames.EDIT} onClick={toggleEdit} minimal />
                </Tooltip>

                <Tooltip content="Archive">
                  <Button
                    icon={IconNames.PROJECTS}
                    onClick={toggleOpen}
                    minimal
                  />
                </Tooltip>
              </>
            )}
          </>
        )}
      </MetaRow>
      <DialogWrapper
        isOpen={isOpen}
        onClose={() => toggleOpen(false)}
        title="Archive"
        body="Are you sure you want to archive this?"
        confirm="ARCHIVE"
        action={handleArchive}
      />
    </>
  );
};

const H3 = styled.h3`
  font-weight: 500;
  margin: 0;
`;

export default EditRow;
